import type { Tokens } from '../../../../theming/types'
import { styles } from '../../../../utilities'
import type { InputTextAreaProps } from '..'

export default (config: {
  props: Partial<InputTextAreaProps>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    default: {
      textarea: {
        ...tokens.fontBodyM,
        appearance: 'none',
        background: tokens.formControlBgColorDefault,
        border: `1px solid ${tokens.formControlBorderColorDefault}`,
        borderRadius: '2px',
        color: tokens.fontColorDefault,
        display: 'block',
        margin: 0,
        minHeight: props.rows === 1 ? undefined : '68px',
        overflow: 'auto',
        padding: '6px 8px',
        width: '100%',

        '&:hover': {
          borderColor: tokens.formControlBorderColorHover,
        },
        outline: '1px solid transparent',
        outlineOffset: `-${tokens.focusWidth}`,
        transitionDuration: '100ms',
        transitionProperty: 'border, outline',

        '&:disabled': {
          backgroundColor: tokens.formElementInputBgColorDisabled,
          cursor: 'not-allowed',
          opacity: tokens.opacityDisabled,
        },

        '&:read-only': {
          backgroundColor: tokens.formElementInputBgColorRead,
          borderColor: tokens.form.readOnlyBorderColor,
          color: tokens.form.readOnlyTextColor,
        },

        '&:focus': {
          outline: `${tokens.focusWidth} solid ${tokens.formElementInputBorderColorActive}`,
          outlineOffset: `-${tokens.focusWidth}`,
          border: `1px solid ${tokens.formElementInputBorderColorActive}`,
        },

        '&::placeholder': {
          color: tokens.fontColorSubtle,
          opacity: 1,
        },

        ...styles.touchScreenFormFieldFontSize,
      },
    },

    resizeHorizontal: {
      resize: 'horizontal',
    },

    resizeNone: {
      resize: 'none',
    },

    resizeBoth: {
      resize: 'both',
    },

    resizeVertical: {
      resize: 'vertical',
    },

    invalid: {
      textarea: {
        borderColor: tokens.formElementInputBorderColorError,

        '&:hover': {
          borderColor: tokens.formElementInputBorderColorError,
        },
      },
    },
  } as const
}
